import { styled } from 'styled-components'
import media from 'common-ui-components/src/vtj/theme/media'
import { StyledPriceListContainer } from 'todistukset-ui/src/vtj/components/price-list/PriceListTable.sc'

export const WizardPriceListContainer = styled(StyledPriceListContainer)`
  table {
    th,
    td {
      padding: ${({ theme }) => theme.spacing.xxs}
        ${({ theme }) => theme.spacing.m};
      ${({ theme }) => theme.typography.bodyTextSmall};
      ${media.mobileAndTablet} {
        padding: ${({ theme }) => theme.spacing.xxs}
          ${({ theme }) => theme.spacing.s};
      }
      ${media.mobile} {
        padding: ${({ theme }) => theme.spacing.xxs}
          ${({ theme }) => theme.spacing.xs};
      }
    }

    thead th,
    thead td {
      ${({ theme }) => theme.typography.bodySemiBoldSmall};
    }

    thead,
    tbody {
      th:first-child,
      td:first-child {
        width: 75%;
      }
    }
  }
`
